import React from 'react';
import styled from 'styled-components';

import { Flex, Theme } from 'baukasten';

import type { ActionSpec } from '../types';

const Pill = styled.button<{ $chosen: boolean }>`
  border: 1px solid
    ${({ $chosen }) =>
      $chosen ? 'transparent' : Theme.getColor('grey-light-100')};
  border-radius: 8px;
  padding: ${Theme.getBaseUnit(1)} ${Theme.getBaseUnit(2)};
  font-family: inherit;
  font-size: ${Theme.getFontSize(12)};
  color: ${({ $chosen }) =>
    $chosen ? Theme.getColor('grey-dark') : Theme.getColor('navy')};
  background-color: ${({ $chosen }) =>
    $chosen ? Theme.getColor('grey-light-50') : Theme.getColor('white')};
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${Theme.getColor('grey-light-50')};
  }

  &:disabled {
    cursor: default;
    opacity: ${({ $chosen }) => ($chosen ? 1 : 0.4)};
  }
`;

type Props = {
  actions: ActionSpec[];
  /** Only the newest message can still be acted on; older ones just show what was picked. */
  active: boolean;
  chosen: string | null;
  onAction: (action: ActionSpec) => void;
};

export const ActionSuggestions = ({
  actions,
  active,
  chosen,
  onAction,
}: Props) => {
  if (!actions.length) return null;

  return (
    <Flex gap={1} flexWrap="wrap" alignItems="center">
      {actions.map(action => (
        <Pill
          key={action.payload}
          type="button"
          disabled={!active}
          $chosen={!active && chosen === action.payload}
          onClick={() => onAction(action)}
        >
          {action.label}
        </Pill>
      ))}
    </Flex>
  );
};
